export const SentimentConfig = {
    // claimReloadMs: 5000,
    meReloadMs: 15000
}